<template>
    <div class="error">
        <div class="error-body">
            <Card class="error-body-card">
                <div class="error-body-title">
                    <span>4</span><!--
                    --><span class="span-403-0"><Icon type="md-lock" /></span><!--
                    --><span class="span-403-3">3</span>
                </div>
                <p class="error-body-message">很抱歉，您没有该页面的访问权限！</p>
                <p class="error-body-message">I'm sorry, You don't have permission!</p>

                <!-- 返回按钮组件 -->
                <error-back :backNum="-2"></error-back>
            </Card>
        </div>
    </div>
</template>

<script>
    import errorBack from "./errorBack.vue";

    export default {
        name: "Error403",
        components: {
            errorBack
        },
        methods: {}
    };
</script>

<style lang="less" scoped>
    @import url("./error.less");
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/pages/Error/Error403.vue